module.exports = __webpack_public_path__ + "img/wand.2e392fe6.svg";